import { useMutation, useQuery } from "@tanstack/react-query";
import { CatalogDataResponseItem, CurrentlyProcessedPageResponse } from "../../types";
import { CatalogFormValues } from "./catalog-form.type";
import { api } from "../../api";

const SEND_CATALOG_MUTATION_KEY = 'send-catalog-mutation-key';
const GET_CURRENTLY_PROCESSED_PAGE_QUERY_KEY = 'get-currently-processed-page-key';
const CURRENTLY_PROCESSED_PAGE_REFETCH_INTERVAL_MS = 5000;

const sendCatalogData = async (data: CatalogFormValues) => {
    const formData = new FormData();

    formData.append('catalogFile', data.catalogFile)

    const { data: result } = await api.post<CatalogDataResponseItem[]>(
        '/catalog',
        formData,
        { 
            params: {
                'start-page-index': Math.max(data?.startPageIndex - 1, 0),
                'end-page-index': Math.max(data?.endPageIndex - 1, 1),
                'catalog-variant': `${data.producerName}-${data.catalogVariant}`
            }
        }
    )

    return result;
}

const getCurrentlyProcessedPageData = async () => 
    api.get('/processed-page-number').then(({ data }) => data);

export const useSendCatalogData = () => {
    return useMutation<CatalogDataResponseItem[], unknown, CatalogFormValues>({
        mutationKey: [SEND_CATALOG_MUTATION_KEY],
        mutationFn: (formData) => sendCatalogData(formData) 
    })
}

export const useCurrentlyProcessedPageData = (isEnabled: boolean) => 
    useQuery<CurrentlyProcessedPageResponse, unknown>({
        queryKey: [GET_CURRENTLY_PROCESSED_PAGE_QUERY_KEY],
        queryFn: getCurrentlyProcessedPageData,
        enabled: isEnabled,
        refetchInterval: CURRENTLY_PROCESSED_PAGE_REFETCH_INTERVAL_MS
    })
